.title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}
.actions {
    display: flex;
    justify-content: center;
    color: black;
}
.details {
    display: flex;
    justify-content: center;
    padding-bottom: 8px;
}
